/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ad_LabelInputs */

const en_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD audio track`)
};

const fr_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste audio publicitaire`)
};

const de_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Audiospur`)
};

const it_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia audio AD`)
};

const ru_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиодорожка AD`)
};

const es_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pista de audio AD`)
};

const zh_cn2_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD 音频轨道`)
};

const ja_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告音声トラック`)
};

const hi_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विज्ञापन ऑडियो ट्रैक`)
};

const pt_pt2_audio_embed_export_ad_label = /** @type {(inputs: Audio_Embed_Export_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixa de áudio AD`)
};

/**
* | output |
* | --- |
* | "AD audio track" |
*
* @param {Audio_Embed_Export_Ad_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ad_label = /** @type {((inputs?: Audio_Embed_Export_Ad_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ad_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_ad_label(inputs)
	if (locale === "de") return de_audio_embed_export_ad_label(inputs)
	if (locale === "it") return it_audio_embed_export_ad_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_ad_label(inputs)
	if (locale === "es") return es_audio_embed_export_ad_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_ad_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_ad_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_ad_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_ad_label(inputs)
	return en_audio_embed_export_ad_label(inputs)
});